import { apiBaseUrl } from '../core/globalVariables.js';

import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import harrierPolygonLayer from '../core/harrierPolygonLayer';
import { center } from '@turf/turf';
import { bbox } from '@turf/turf';
import booleanContains from '@turf/boolean-contains';
import CommsToAPI from '../ui/modals/commsToAPI.js'

import { ClockLoader } from "react-spinners";

import { getAvailableYears } from './getAvailableYears';

import {
  fmesh,
  fullmesh,
} from '../core/globalVariables.js';

const DataLoad = ({
  isMenuLoadClick,
  closeLoadMenu,
  globalRefs,
  globalState,
  mapLoaded,
  setLoggedInToAPI,
  setLoadedPercentage,
  resetLeftSubMenu,
}) => {

  const [mapData, setMapData] = useState([]);
  const [initFetch, setInitFetch] = useState(0);
  let userID = globalState.userID;
  let setUserID = globalState.setUserID
  let initialDataLoadComplete = globalState.initialDataLoadComplete;
  let setInitialDataLoadComplete = globalState.setInitialDataLoadComplete;

  const message = 'Loading new Data'

  let debugMode = globalState.debugMode;
  let setDebugMode = globalState.setDebugMode;

  const mapRef = globalRefs.mapRef;
  const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
  const longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
  const originalGeoJSONforComparingRef = globalRefs.originalGeoJSONforComparingRef;
  let centroidRef = globalRefs.centroidRef;
  let APIReportMessage = globalState.APIReportMessage;
  let setAPIReportMessage = globalState.setAPIReportMessage;
  let currentMapIdRef = globalRefs.currentMapIdRef;
  let setRecentChangeList = globalState.setRecentChangeList;
  const setIsLoading = globalState.setIsLoading;
  const setisMenuLoadClick = globalState.setisMenuLoadClick;
  const currentMapId = globalState.currentMapId;
  const setCurrentMapId = globalState.setCurrentMapId;
  const selectedYearEditing = globalState.selectedYearEditing;
  let workingLocally = globalState.workingLocally;
  let setUserEmail = globalState.setUserEmail;
  let universalParcelDifferentiator = globalState.universalParcelDifferentiator;
  let universalColorPaletteName = globalState.universalColorPaletteName;
  let setAdminUser = globalState.setAdminUser;
  let globalPublicSelectedDataset = globalState.globalPublicSelectedDataset;
  let clickedMapIDtoLoad = globalState.clickedMapIDtoLoad;
  let isThisFirstLoadOfNewData = 0;
  let isDrawing = globalState.isDrawing;
  let setAvailableKeys = globalState.setAvailableKeys;
  let setAvailableValues = globalState.setAvailableValues;
  let yearsAvailable = globalState.yearsAvailable;
  let setYearsAvailable = globalState.setYearsAvailable;
  let setisComparing = globalState.setisComparing;
  const selectedKey = globalState.selectedKey;
  const selectedMetric = globalState.selectedMetric;
  const setisLeftSubDrawerOpen = globalState.setisLeftSubDrawerOpen;
  const setGlobalPublicSelectedDataset = globalState.setGlobalPublicSelectedDataset;
  const setClickedMapIDtoLoad = globalState.setClickedMapIDtoLoad;
  const isWorkingWithinRealm = globalState.isWorkingWithinRealm;
  const setIsWorkingWithinRealm = globalState.setIsWorkingWithinRealm;
  const setMapMetaData = globalState.setMapMetaData;
  const selectedFirstPrivateMapParentRef = globalRefs.selectedFirstPrivateMapParentRef;
  const devDeployment = globalState.devDeployment;
  const mapOverview = globalState.mapOverview;
  const setMapOverview = globalState.setMapOverview;
  const dataHasNoKeys = globalState.dataHasNoKeys;
  const setDataHasNoKeys = globalState.setDataHasNoKeys;
  const dataHasNoValues = globalState.dataHasNoValues;
  const setDataHasNoValue = globalState.setDataHasNoValues;
  const setMultuGroupSelectedArray = globalState.setMultuGroupSelectedArray;
  const baseMapIDRefForRefWhenUsingOriginalLayer = globalRefs.baseMapIDRefForRefWhenUsingOriginalLayer;
  const setSelectedYearEditing = globalState.setSelectedYearEditing;

  let initiallyLoadedDataBoundingBox = useRef();
  let UpdatedMapLoadedPolygonCountAfterPanRef = useRef();
  let UpdatedMapLoadedPolygonCountAfterKeyValueChange = useRef();
  let simplificationLevelRef = useRef('0');
  const selectedKeyRef = useRef(selectedKey);
  const selectedMetricRef = useRef(selectedMetric);

  let clickedInfoTab = globalState.clickedInfoTab;
  let setClickedInfoTab = globalState.setClickedInfoTab;

  let userIsMapOwner = globalState.userIsMapOwner;
  let setUserIsMapOwner = globalState.setUserIsMapOwner;

  // 

  let LOADINGPARAM_startOfLoad = globalState.LOADINGPARAM_startOfLoad;
  let setLOADINGPARAM_startOfLoad = globalState.setLOADINGPARAM_startOfLoad;

  let LOADINGPARAM_makeScene = globalState.LOADINGPARAM_makeScene;
  let setLOADINGPARAM_makeScene = globalState.setLOADINGPARAM_makeScene;

  let LOADINGPARAM_initAnimation = globalState.LOADINGPARAM_initAnimation;
  let setLOADINGPARAM_initAnimation = globalState.setLOADINGPARAM_initAnimation;

  let LOADINGPARAM_onAdd = globalState.LOADINGPARAM_onAdd;
  let setLOADINGPARAM_onAdd = globalState.setLOADINGPARAM_onAdd;

  let LOADINGPARAM_createShapes = globalState.LOADINGPARAM_createShapes;
  let setLOADINGPARAM_createShapes = globalState.setLOADINGPARAM_createShapes;

  let LOADINGPARAM_applyDateRange = globalState.LOADINGPARAM_applyDateRange;
  let setLOADINGPARAM_applyDateRange = globalState.setLOADINGPARAM_applyDateRange;

  let LOADINGPARAM_resetMapAfterDatesReceived = globalState.LOADINGPARAM_resetMapAfterDatesReceived;
  let setLOADINGPARAM_resetMapAfterDatesReceived = globalState.setLOADINGPARAM_resetMapAfterDatesReceived;

  let LOADINGPARAM_fetchKeyData = globalState.LOADINGPARAM_fetchKeyData;
  let setLOADINGPARAM_fetchKeyData = globalState.setLOADINGPARAM_fetchKeyData;

  let LOADINGPARAM_fetchNumericData = globalState.LOADINGPARAM_fetchNumericData;
  let setLOADINGPARAM_fetchNumericData = globalState.setLOADINGPARAM_fetchNumericData;

  useEffect(() => {
    selectedKeyRef.current = selectedKey;
    selectedMetricRef.current = selectedMetric;
  }, [selectedKey, selectedMetric]);

  let setSelectedMetric = globalState.setSelectedMetric;
  let setSelectedKey = globalState.setSelectedKey;
  let setLandKeySelectedKey = globalState.setLandKeySelectedKey;
  let setSelectedAggregate = globalState.setSelectedAggregate;
  let setNumericTimeAggregationMethod = globalState.setNumericTimeAggregationMethod;

  // START STAGE 5 - CREATE A NEW MAP LAYER WITH THE NEW GEOJSON - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 5 - CREATE A NEW MAP LAYER WITH THE NEW GEOJSON - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 5 - CREATE A NEW MAP LAYER WITH THE NEW GEOJSON - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  let geoJSONReadyVersion = globalState.geoJSONReadyVersion;
  let setGeoJSONReadyVersion = globalState.setGeoJSONReadyVersion;

  const newMapFromGeojson = (geoJsonData, id) => {
    setNumericTimeAggregationMethod("year")
    setSelectedYearEditing('');
    longstandingGeoJSONRef.current = geoJsonData;
    longstandingGeoJSONRef.current.centroidRef = centroidRef.current.geometry.coordinates;
    if (isThisFirstLoadOfNewData === 0) {
      originalGeoJSONforComparingRef.current = JSON.parse(JSON.stringify(geoJsonData));
      isThisFirstLoadOfNewData = 1;
    }
    setRecentChangeList([])
    setYearsAvailable(getAvailableYears(longstandingGeoJSONRef.current));
    // 
    setLOADINGPARAM_startOfLoad(true)
    setGeoJSONReadyVersion(v => v + 1);
    if (mapRef.current) {
      fmesh.children.forEach((child) => {
        child.traverse((object) => {
          object.geometry?.dispose();
          if (Array.isArray(object.material)) object.material.forEach((material) => material.dispose());
          else object.material?.dispose();
        });
        fmesh.remove(child);
      });
      fullmesh.children.forEach((child) => {
        fullmesh.remove(child);
      });
      fmesh.children.length = 0;
      fullmesh.children.length = 0;
      if (mapRef.current.getLayer('Polygons')) {
        mapRef.current.removeLayer('Polygons');
      }
      let startPoint = null;
      const DRAG_THRESHOLD = 3;
      mapRef.current.on('mousedown', (e) => {
        if (e.originalEvent.button !== 0) return;
        startPoint = e.point;
      });
      mapRef.current.on('mouseup', (e) => {
        if (e.originalEvent.button !== 0) return;
        const dx = e.point.x - startPoint.x;
        const dy = e.point.y - startPoint.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (distance < DRAG_THRESHOLD) {
          polygonCustomLayerRef.current.raycast(e.point, false);
        }
      });
      const bounds = bbox(longstandingGeoJSONRef.current);
      initiallyLoadedDataBoundingBox.current = bounds;
      mapRef.current.fitBounds(
        [
          [bounds[0], bounds[1]],
          [bounds[2], bounds[3]],
        ],
        {
          padding: 20,
          duration: 2,
          pitch: 60,
          bearing: -20
        }
      );
      setTimeout(() => {
        if (userID) {
          setInitialDataLoadComplete(true);
        }
      }, 1000);
    }
  };

  // START STAGE 4 - FETCH THE USERS INITIAL OR SELECTED GEOJSON FROM THE API - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 4 - FETCH THE USERS INITIAL OR SELECTED GEOJSON FROM THE API - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 4 - FETCH THE USERS INITIAL OR SELECTED GEOJSON FROM THE API - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  const getBoundingBoxFromViewport = () => {
    if (!mapRef.current) throw new Error('Map reference not available');
    const bounds = mapRef.current.getBounds();
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    return `${sw.lng} + ${sw.lat} + ${ne.lng} + ${ne.lat}`;
  };

  const fetchInitialGeoJsonForInitialView = async (id, simplify) => {
    const token = localStorage.getItem('token');
    const srid = 4326;
    if (!token) {
      throw new Error('No token in local storage');
    }
    const bb = getBoundingBoxFromViewport();
    const params = new URLSearchParams({
      srid: String(srid),
      properties: '*',
      simplify: 1,
    });
    const response = await fetch(
      `${apiBaseUrl}/api/maps/${id}/features?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Feature request failed: ${response.status} ${errorText}`
      );
    }
    const geoJsonData = await response.json();
    const responseData = geoJsonData;
    // GeometryCollection is represented as several ordinary features so each
    // geometry can be rendered and picked by the custom Three.js layer.
    const asRenderableFeatures = (detail, geometry, part = 0) => {
      if (geometry.type === 'GeometryCollection') {
        return geometry.geometries.flatMap((child, index) =>
          asRenderableFeatures(detail, child, `${part}.${index}`)
        );
      }
      return [{
        type: 'Feature',
        external_ids: detail.external_ids,
        feature_data_simple: detail.feature_data_simple,
        feature_data_simple_timeseries: detail.feature_data_simple_timeseries,
        feature_data_standard: { ...detail.feature_data_standard },
        feature_data_standard_calculated: detail.feature_data_standard_calculated,
        geometry,
        // Keep the server UUID unchanged; geometry part IDs are only for debugging.
        skylark_id: detail.skylark_id,
        geometry_part_id: part === 0 ? undefined : String(part),
      }];
    };
    const responseGeoJsonData = {
      type: 'FeatureCollection',
      features: responseData.flatMap((detail) => asRenderableFeatures(detail, detail.geometry)),
    };
    centroidRef.current =
      center(responseGeoJsonData);
    newMapFromGeojson(
      responseGeoJsonData,
      id
    );
    return responseGeoJsonData;

  };

  const fetchMapMetaForInitialGeoJSON = async (id) => {

    setAvailableKeys([]);

    setAvailableValues([]);

    setMultuGroupSelectedArray([]);

    // 
    setLOADINGPARAM_startOfLoad(false)
    setLOADINGPARAM_makeScene(false)
    setLOADINGPARAM_initAnimation(false)
    setLOADINGPARAM_onAdd(false)
    setLOADINGPARAM_createShapes(false)
    setLOADINGPARAM_applyDateRange(false)
    setLOADINGPARAM_resetMapAfterDatesReceived(false)
    setLOADINGPARAM_fetchKeyData(false)
    setLOADINGPARAM_fetchNumericData(false)
    // 

    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('No token in local storage');
    }

    const response = await fetch(
      `${apiBaseUrl}/api/maps/${id}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {

      const errorText = await response.text();

      throw new Error(
        `Map metadata request failed: ${response.status} ${errorText}`
      );

    }

    const mapOverview = await response.json();

    if (debugMode) {

      const timestamp =
        new Date().toISOString();

      console.groupCollapsed(
        `${timestamp} mapOverview`
      );

      console.log(
        JSON.stringify(
          mapOverview,
          null,
          2
        )
      );

      console.groupEnd();

    }

    const workingWithinRealm =
      mapOverview.realms?.length > 0;

    setIsWorkingWithinRealm(
      workingWithinRealm
    );

    setMapOverview(
      mapOverview
    );

    if (
      !mapOverview.owner ||
      mapOverview.owner.id === userID
    ) {

      if (debugMode) {

        console.log(
          "I OWN THIS MAP"
        );

      }

      setUserIsMapOwner(true);

    } else {

      if (debugMode) {

        console.log(
          "I DON'T OWN THIS MAP"
        );

      }

      setUserIsMapOwner(false);

    }

    setMapMetaData(
      mapOverview.feature_header
    );

    setClickedInfoTab(
      "DATA"
    );

    const timeseriesKeysWithinMapMeta =
      mapOverview
        .feature_header
        ?.define_feature_data_simple_timeseries || {};

    const stringKeys = [];
    const stringValues = [];

    const sortedEntries = Object.entries(
      timeseriesKeysWithinMapMeta
    ).sort(([keyA, valueA], [keyB, valueB]) => {

      const orderA =
        typeof valueA.display_order === 'number'
          ? valueA.display_order
          : Number.MAX_SAFE_INTEGER;

      const orderB =
        typeof valueB.display_order === 'number'
          ? valueB.display_order
          : Number.MAX_SAFE_INTEGER;

      if (orderA !== orderB) {
        return orderA - orderB;
      }

      return keyA.localeCompare(keyB);
    });

    if (workingWithinRealm) {

      for (const [key, value] of sortedEntries) {

        if (
          value.display_hint?.includes(
            'quantifiable'
          )
        ) {

          if (
            value.display_by_default !== false
          ) {

            stringValues.push(key);

          }

        }

      }

    } else {

      for (const [key, value] of sortedEntries) {

        if (
          value.display_by_default === false
        ) {
          continue;
        }

        if (value.type === 'number') {

          stringValues.push(key);

        } else if (value.type === 'string') {

          stringKeys.push(key);

        }

      }

    }

    setAvailableKeys(stringKeys);

    setAvailableValues(stringValues);

    if (stringKeys.length > 0) {

      setSelectedKey(stringKeys[0]);
      setLandKeySelectedKey(stringKeys[0]);

    } else {

      setSelectedKey(null);

    }

    if (stringValues.length > 0) {

      setSelectedMetric(stringValues[0]);

    } else {

      setSelectedMetric(null);

    }

    return {
      workingWithinRealm,
      availableKeys: stringKeys,
      availableValues: stringValues,
    };
  };

  const fetchInitialMapGeoJSON = async (id) => {
    try {
      currentMapIdRef.current = id;
      baseMapIDRefForRefWhenUsingOriginalLayer.current = id;
      const meta = await fetchMapMetaForInitialGeoJSON(id);
      await fetchInitialGeoJsonForInitialView(
        id,
        simplificationLevelRef.current
      );
    } catch (error) {
      console.error('Error in fetchMapDetails:', error);
    }
  };

  // START STAGE 2 - INITIAL CHECK IF USER LOAD PRIVATE MAP ELSE - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 2 - INITIAL CHECK IF USER LOAD PRIVATE MAP ELSE - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 2 - INITIAL CHECK IF USER LOAD PRIVATE MAP ELSE - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect(() => {

    if (userID) {

      const fetchAllMapDataForSelectingFirstAvailableMapForInitialLoad = async () => {

        try {

          if (
            userID === process.env.REACT_APP_DEV_USER_ID &&
            devDeployment
          ) {

            if (debugMode) {

              const timestamp =
                new Date().toISOString();

              console.log(
                timestamp +
                " " +
                "🤓 Is user a dev? YES"
              );

            }

            fetchInitialMapGeoJSON(
              '83ff7acd-fbef-4d5c-b29e-2f4d242960d6'
            );

          } else {

            if (debugMode) {

              const timestamp =
                new Date().toISOString();

              console.log(
                timestamp +
                " " +
                "🥳 Is user a dev? NO"
              );

            }

            fetchInitialMapGeoJSON(
              'fd8fabf7-f618-42f6-85b0-fa3406567860'
            );

          }

        } catch (error) {

          console.error(
            'Error fetching map data:',
            error
          );

        }

      };

      fetchAllMapDataForSelectingFirstAvailableMapForInitialLoad();

    }

  }, [userID, setAdminUser, mapLoaded]);

  // LOAD MAP FUNCTIONALITY (PRIVATE) - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect(() => {
    if (clickedMapIDtoLoad) {
      fetchInitialMapGeoJSON(clickedMapIDtoLoad);
    }
  }, [clickedMapIDtoLoad]);

  // START STAGE 1 - WHEN THE MAP LAYER IS LOADED CHECK IF USER LOGGED IN - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 1 - WHEN THE MAP LAYER IS LOADED CHECK IF USER LOGGED IN - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 1 - WHEN THE MAP LAYER IS LOADED CHECK IF USER LOGGED IN - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect(() => {
    if (mapData && initFetch === 0 && mapLoaded === true) {
      const getUserInfo = async () => {
        try {
          setIsLoading(true);
          const token = localStorage.getItem('token');
          if (!token) {
            throw new Error('No token in local storage');
          }
          const response = await fetch(
            `${apiBaseUrl}/api/info`,
            {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
          );
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
              `User info request failed: ${response.status} ${errorText}`
            );
          }
          const data = await response.json();
          setUserEmail(data.user.email);
          const timestamp =
            new Date().toISOString();
          if (debugMode) {
            console.log(
              timestamp +
              " " +
              "✅ Logged in user id: " +
              data.user.id
            );
          }
          setUserID(data.user.id);
          setisMenuLoadClick(false);
          setLoggedInToAPI(true);
          setGlobalPublicSelectedDataset(null);
        } catch (error) {
          console.error(
            'Error fetching user info:',
            error
          );
          setLoggedInToAPI(false);
          setisMenuLoadClick(true);
          // loadPublicData();
        }
      };
      getUserInfo();
      setInitFetch(1);
    }
  }, [mapData, initFetch, mapLoaded]);

  return (
    <>
    </>
  )
};

export default DataLoad;
